import {AxiosInstance} from "axios"
import {LDAPServerInfo} from "../models/ldap-server-info"

export const LDAPServerService = (axiosInstance: AxiosInstance) => {
  const apiBaseUrl = "/organization-admin/api/v1/ldap-servers"

  return {
    addLdapServer: async (ldapServerInfo: LDAPServerInfo) =>
      axiosInstance
        .post(apiBaseUrl, ldapServerInfo)
        .then(response => response.data.id)
        .catch(() => {
          throw new Error("Add ldap server failed")
        })
  }
}